import React from "react";
import { render } from "react-dom";

import FundraiserSignup from "widgets/FundraiserSignup";

import "./style.scss";

if (document.getElementById("js-fundraiser-signup") !== null) {
  render(
    <FundraiserSignup />,
    document.getElementById("js-fundraiser-signup"),
  );
}
